import { withZod } from '@remix-validated-form/with-zod'
import { upperCase } from 'lodash'
import { useState } from 'react'
import { z } from 'zod'
import { zfd } from 'zod-form-data'
import Button from '../Button'
import FormCombo from '../form/FormCombo'
import FormInput from '../form/FormInput'
import { SmartForm } from '../form/SmartForm'
import { LeadOverrideConfigType } from 'app/types/entities'
import { enforceMinMax } from 'lib/enforceMinMaxInput'
import { OptionType } from 'types/OptionType'

const createSchema = z.object({
  amount: zfd.numeric(),
  unit: z.enum([`days`, `weeks`]),
})

export const createLeadOverrideValidator = withZod(createSchema)

export default function LeadOverridePanel({
  config,
  onSaved,
  onCancel,
}: {
  config?: LeadOverrideConfigType
  onSaved: (data: any) => void
  onCancel: () => void
}) {
  const [selectedUnit, setSelectedUnit] = useState<OptionType | undefined>(
    config
      ? {
          id: config.unit,
          name: upperCase(config.unit),
          value: config.unit,
        }
      : undefined,
  )

  return (
    <SmartForm
      className="!mt-0 !max-w-none !gap-y-0"
      validator={createLeadOverrideValidator}
      onSubmit={(data) => onSaved(data)}
      preventSubmit
      hideButtons
    >
      <div className="col-span-6 flex flex-col gap-y-6 p-4">
        <FormInput
          name="amount"
          label="Amount"
          type="number"
          max={selectedUnit?.value === `days` ? 30 : 4}
          min={1}
          required={true}
          labelClassName="text-label-sm text-strong"
          defaultValue={config?.amount}
          cols={6}
          onChange={(e) => enforceMinMax(e)}
        />
        <FormCombo
          cols={6}
          name="unit"
          label="Units"
          placeholder="Select a unit"
          options={[
            { id: `days`, name: `Days`, value: `days` },
            { id: `weeks`, name: `Weeks`, value: `weeks` },
          ]}
          value={selectedUnit}
          onChange={(option) => setSelectedUnit(option)}
          labelClassName="text-label-sm text-strong"
        />
      </div>
      <div className="relative bottom-0 z-10 col-span-6 flex justify-end rounded-b-lg border-b border-t border-default bg-surface px-4 py-3">
        <div className="flex justify-end gap-4">
          <Button label="Cancel" mode="white" size="md" onClick={() => onCancel()} />
          <Button type="submit" label="Save" mode="primary" size="md" />
        </div>
      </div>
    </SmartForm>
  )
}
